import React from 'react';

const ZooIcon = (props) => {
  return (
    <img
      alt="Zoo"
      src="/static/images/icons/place_types/zoo.svg"
      {...props}
    />
  );
};

export default ZooIcon;
